// Angular
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ROLES } from "app/_constants/roles";
import { AlphaGuard } from "app/_guards/alpha.guard";

// Components 
import { DossierListComponent } from "./dossier-list/dossier-list.component";

const routes: Routes = [
  {
    path: "",
    data: {
      title: "Dossier",
      breadcrumbs: "",
    },
    children: [
      {
        path: "dossierList",
        component: DossierListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS, ROLES.ADVANCED_MEDICAL_ASSISTANT, ROLES.INTERMEDIATE_MEDICAL_ASSISTANT, ROLES.BEGINNER_MEDICAL_ASSISTANT]
          }
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AlphaGuard],
})
export class DossierRoutingModule { }
